export const INSTALLED_DESKTOP_PROTOCOL = 'lvbworkspace:';

export function installedDesktopBootstrapUnavailable(protocol, desktop) {
  if (protocol !== INSTALLED_DESKTOP_PROTOCOL) return false;
  return !desktop
    || typeof desktop.backendUrl !== 'string'
    || !desktop.backendUrl.trim()
    || typeof desktop.localBackendUrl !== 'string'
    || !desktop.localBackendUrl.trim()
    || typeof desktop.getActiveSession !== 'function';
}

export function resolveBackendUrl(protocol, desktop, browserBackendUrl) {
  if (protocol === INSTALLED_DESKTOP_PROTOCOL) {
    return installedDesktopBootstrapUnavailable(protocol, desktop)
      ? null
      : desktop.backendUrl;
  }
  return desktop?.backendUrl || browserBackendUrl;
}
